import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { CartDrawer } from '@components/CartDrawer/CartDrawer'
import Header from '@components/Header'
import renderLiquidLinks from '@components/Header/utils/renderLiquidLinks'
import {
  withApollo,
  withErrorBoundary,
  withExchangeRates,
  withI18next,
  withStaffPickImage,
  withTheme,
} from '@hocs'
import type { CartDrawerData } from '@velasca/types'

export const renderHeaderApp = (
  homePageEl: HTMLElement | null,
  switchCountryEl: HTMLElement | null,
  cartPageEl: HTMLElement | null,
  giftCardProductEl: HTMLElement | null,
  apparelProductEl: HTMLElement | null,
  apparelCategoryEl: HTMLElement | null,
  apparelMacroCategoryEl: HTMLElement | null,
  cartDrawerData: CartDrawerData,
  headerEl: HTMLElement | null,
  headerDataEl: HTMLElement | null,
  headerData: any,
  promotionalBannerData: any,
) => {
  if (
    !giftCardProductEl &&
    !apparelProductEl &&
    !apparelCategoryEl &&
    !apparelMacroCategoryEl &&
    !cartPageEl &&
    !homePageEl &&
    headerEl &&
    headerDataEl
  ) {
    const HeaderApp = () => (
      <>
        <CartDrawer emptyCartCtas={cartDrawerData?.ctas || []} />
        <Header
          promotionalBanner={promotionalBannerData || {}}
          miscHeaderData={headerData?.miscData}
          reduced={headerEl.getAttribute('data-reduced') === 'true' || false}
          menu={
            renderLiquidLinks(
              headerData?.nav,
              headerData?.miscData?.liquidLinks,
            ) ?? undefined
          }
          lowerMenu={
            headerData?.mobileOnlyNav &&
            renderLiquidLinks(
              headerData?.mobileOnlyNav,
              headerData?.miscData?.liquidLinks,
            )
          }
          sticky={
            headerEl.getAttribute('data-sticky') === 'true' ||
            switchCountryEl?.getAttribute('data-header-sticky') ||
            false
          }
        />
      </>
    )

    const HeaderAppWrapper = pipe(
      HeaderApp,
      withStaffPickImage,
      withExchangeRates,
      withI18next,
      withErrorBoundary,
      withTheme,
      withApollo,
    )

    ReactDOM.createRoot(headerEl).render(<HeaderAppWrapper />)
  }
}
